export enum Department {
  Accounting = 'ACCOUNTING',
  Labor = 'LABOR',
  Fiscal = 'FISCAL',
  Billing = 'BILLING',
  General = 'GENERAL'
}
